import { Component, Element, Event, EventEmitter, h, Host, Prop, State, Watch } from '@stencil/core'
import { Back, gsap } from 'src/lib/gsap'

import { FontSizeType } from '../../tailwind'
import { classes } from '../../utils/css'

@Component({
  tag: 'ui-stars',
})
export class Stars {
  @Element() el: HTMLUiStarsElement

  @Event() rated: EventEmitter<number>

  @Prop() total = 5
  @Prop() value = null
  @Prop() size: FontSizeType = null
  @Prop() disabled = false
  @Prop() filled = false
  @Prop() spacing = '0.2em'

  @State() displayValue = this.value

  totalWidth: number
  starsEl: HTMLSpanElement

  @Watch('value')
  onValueChange() {
    const star = this.el.querySelectorAll('ui-icon')[this.value - 1]
    if (star) {
      gsap.to(star, { scale: 1.3, duration: 0.3, yoyo: true, repeat: 1, ease: Back.easeInOut })
    }
    this.rated.emit(this.value)
  }

  render() {
    return (
      <Host
        onMouseLeave={() => (this.displayValue = this.value)}
        class={`
          bg-surface-highest bg-opacity-0 flex flex-wrap leading-none flex-shrink-0
          ${classes(this.disabled, 'pointer-events-none')}
          ${classes(this.size !== null, `text-${this.size}`)}
        `}
      >
        {Array.from({ length: this.total }).map((_u, i) => {
          i += 1
          const filled = i <= this.displayValue
          return (
            <ui-icon
              icon='star-fill'
              onMouseEnter={() => {
                this.displayValue = i
              }}
              onClick={() => {
                this.value = this.displayValue
              }}
              class={`
                cursor-pointer
                ${classes(filled, 'text-info-warn', 'text-surface-highest')}
              `}
              style={{ marginRight: i === this.total ? '0' : this.spacing }}
            />
          )
        })}
      </Host>
    )
  }
}
